import type { ReactNode } from 'react';
import { Card } from 'antd';
import { useTranslation } from 'react-i18next';

/** Centered single-card chrome shared by every enrollment screen. */
export function PortalShell({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  return (
    <div className="portal-page">
      <Card className="portal-card">
        <div className="portal-brand">{t('brand')}</div>
        {children}
      </Card>
    </div>
  );
}
